import type { RealtimeTranslationStatus } from "../lib/realtimeTranslation";
import type { TargetLanguage } from "../shared/languages";
import { UI_COPY, type UiCopyKey } from "../shared/uiCopy";

export type StatusBadgeProps = {
  language: TargetLanguage;
  status: RealtimeTranslationStatus;
};

const STATUS_COPY_KEYS: Record<RealtimeTranslationStatus, UiCopyKey> = {
  idle: "statusIdle",
  connecting: "statusConnecting",
  listening: "statusListening",
  reconnecting: "statusReconnecting",
  muted: "statusMuted",
  error: "statusError",
};

export function StatusBadge({ language, status }: StatusBadgeProps) {
  return (
    <span className={`status-badge status-badge--${status}`} role="status" aria-live="polite">
      <span className="status-badge__signal" aria-hidden="true" />
      {UI_COPY[language][STATUS_COPY_KEYS[status]]}
    </span>
  );
}
